import * as tslib_1 from "tslib";
import Checkable from "../Checkable";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import "./Checkbox.css";

var Checkbox =
/** @class */
function (_super) {
  tslib_1.__extends(Checkbox, _super);

  function Checkbox() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getColors = function () {
      var _a = _this.props,
          checked = _a.checked,
          disabled = _a.disabled,
          normalCheckedColor = _a.normalCheckedColor,
          normalUncheckedColor = _a.normalUncheckedColor,
          disabledCheckedColor = _a.disabledCheckedColor,
          disabledUncheckedColor = _a.disabledUncheckedColor;
      return {
        backgroundColor: disabled ? checked ? '#fff' : disabledUncheckedColor : '#fff',
        strokeColor: disabled ? checked ? disabledCheckedColor : disabledUncheckedColor : checked ? normalCheckedColor : normalUncheckedColor
      };
    };

    return _this;
  }

  Checkbox.prototype.render = function () {
    var _a = this.props,
        size = _a.size,
        checked = _a.checked,
        disabled = _a.disabled,
        blockClassName = _a.blockClassName;

    var _b = this.getColors(),
        backgroundColor = _b.backgroundColor,
        strokeColor = _b.strokeColor;

    return React.createElement(Checkable, tslib_1.__assign({}, this.props, {
      type: "checkbox"
    }), React.createElement("div", {
      className: blockClassName + "__image-wrapper",
      role: "checkbox",
      "aria-checked": checked,
      tabIndex: disabled ? -1 : 0
    }, React.createElement("svg", {
      viewBox: "0 0 20 20",
      height: size,
      width: size
    }, React.createElement("g", {
      className: blockClassName + "__box",
      fill: backgroundColor,
      stroke: strokeColor
    }, React.createElement("rect", {
      width: "20",
      height: "20",
      rx: "3",
      stroke: "none"
    }), React.createElement("rect", {
      x: ".5",
      y: ".5",
      width: "19",
      height: "19",
      rx: "2.5",
      fill: "none"
    })), React.createElement("path", {
      className: blockClassName + "__checkmark",
      fill: "none",
      stroke: strokeColor,
      strokeWidth: "1.3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: "10",
      d: "M4.3 10.8l3.6 3.8 7.8-7.8",
      strokeDasharray: "17px",
      strokeDashoffset: checked ? '0px' : '17px'
    }))));
  };

  Checkbox.propTypes = {
    blockClassName: PropTypes.string,
    size: PropTypes.number,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    normalCheckedColor: PropTypes.string,
    normalUncheckedColor: PropTypes.string,
    disabledCheckedColor: PropTypes.string,
    disabledUncheckedColor: PropTypes.string
  };
  Checkbox.defaultProps = {
    blockClassName: 'nx-checkbox',
    size: 16,
    normalCheckedColor: '#8dc549',
    normalUncheckedColor: '#ccc',
    disabledCheckedColor: '#ccc',
    disabledUncheckedColor: '#f2f2f2'
  };
  return Checkbox;
}(Component);

export default Checkbox;

try {
  // @ts-ignore
  Checkbox.__docgenInfo = {
    "description": "",
    "displayName": "Checkbox",
    "props": {
      "normalCheckedColor": {
        "defaultValue": {
          value: "#8dc549"
        },
        "description": "",
        "name": "normalCheckedColor",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "normalUncheckedColor": {
        "defaultValue": {
          value: "#ccc"
        },
        "description": "",
        "name": "normalUncheckedColor",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "disabledCheckedColor": {
        "defaultValue": {
          value: "#ccc"
        },
        "description": "",
        "name": "disabledCheckedColor",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "disabledUncheckedColor": {
        "defaultValue": {
          value: "#f2f2f2"
        },
        "description": "",
        "name": "disabledUncheckedColor",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "size": {
        "defaultValue": {
          value: "16"
        },
        "description": "",
        "name": "size",
        "required": true,
        "type": {
          "name": "number"
        }
      },
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "blockClassName": {
        "defaultValue": {
          value: "nx-checkbox"
        },
        "description": "",
        "name": "blockClassName",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "shouldPropagate": {
        "defaultValue": null,
        "description": "",
        "name": "shouldPropagate",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "type": {
        "defaultValue": null,
        "description": "",
        "name": "type",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "disabled": {
        "defaultValue": null,
        "description": "",
        "name": "disabled",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "checked": {
        "defaultValue": null,
        "description": "",
        "name": "checked",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "onChange": {
        "defaultValue": null,
        "description": "",
        "name": "onChange",
        "required": false,
        "type": {
          "name": "((checked: boolean, event: SyntheticEvent<Element>) => void) | undefined"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}